/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useRef } from 'react'
import ApexCharts, { ApexOptions } from 'apexcharts'
import { KTSVG, toAbsoluteUrl } from '../../../helpers'
import { getCSS, getCSSVariableValue } from '../../../assets/ts/_utils'
import { useThemeMode } from '../../layout/theme-mode/ThemeModeProvider'
import { Link } from 'react-router-dom'
import { getColorCodeFromDivision, getHappinessScore } from '../../../helpers/utility'

type Props = {
  id: string
  className: string
  data?: ChartsWidget2Dto[]
  texts?: string[]
  mainLabel?: string
  sideLabel?: string
  functionSubmit?: any
  functionDownload?: any
  isDownloadContinue?: boolean
  isShowFilterSubjects?: boolean
  height?: string
  isCompetitorControl?: boolean
  warnings: { url: string, message: string }[]
  isWaringImageMirror?: boolean
  isHorizontal?: boolean
}

function getColor(color: string) {
  return "#" + color;
}

export class ChartsWidget2Dto { label = ""; subject = ""; firstCount = 0; secondCount = 0; thirdCount = 0; fourthCount = 0; }

const ChartsWidget2: React.FC<Props> = ({
  id = '',
  className,
  data = [new ChartsWidget2Dto()],
  texts = ["Net Profit"],
  mainLabel = "Your Statistics",
  sideLabel = "",
  functionDownload,
  isDownloadContinue = false,
  height = "250px",
  isCompetitorControl = false,
  warnings = [],
  isWaringImageMirror = false,
  isHorizontal = false
}) => {
  const chartRef = useRef<HTMLDivElement | null>(null)
  const { mode } = useThemeMode()
  // const [countChart, updateCountChart] = React.useState(0);
  const [previusData, updatePreviusData] = React.useState([new ChartsWidget2Dto()]);
  const [isChartCreated, updateIsChartCreated] = React.useState(false);
  const [heightInt, updateHeightInt] = React.useState(0);
  const [chartId, updateChartId] = React.useState("id");
  const [totalDataCount, updateTotalDataCount] = React.useState(-1);

  useEffect(() => {
    // if (countChart === data.length)
    //   return

    // updateCountChart(data.length)

    updateTotalDataCount(data.reduce((sum, currentItem) => { return sum + currentItem.firstCount;}, 0))
    refreshChart()
  })
  let options = null;
  const refreshChart = () => {
    if (!chartRef.current) {
      // if (data![0].firstCount !== -1) {
        updatePreviusData(data)
      // }
      return
    }

    if (isChartCreated) {
      if (JSON.stringify(previusData) === JSON.stringify(data)) {
        return
      }
      updatePreviusData(data)
    }

    var element = document.getElementById("apexcharts" + chartId);
    if (typeof (element) != 'undefined' && element != null) {

      options = getChartOptions(chartId, heightInt, data, texts, isHorizontal)

      ApexCharts.exec(chartId, 'updateOptions', options, true, true);
    } else {
      const chartId = "id" + Math.random().toString(16).slice(2)
      updateChartId(chartId)

      const height = parseInt(getCSS(chartRef.current, 'height'))
      updateHeightInt(height)

      options = getChartOptions(chartId, heightInt, data, texts, isHorizontal)

      const chart = new ApexCharts(chartRef.current, options)
      chart.render()

      updateIsChartCreated(true)
    }
  }
  // const functionDownloadPdf = async (sourceType: string, date: string, subject: string, minCount: string, channelType: string, competitor: string) => {
  //   var chart = new ApexCharts(document.querySelector("#chart"), options);
  //   chart.render().then(() => {
  //       chart.dataURI().then(({ "imgURI", blob }) => { 
  //           var pdf = new jsPDF();
  //           pdf.addImage("imgURI", 'PNG', 0, 0);
  //           pdf.save("download.pdf");
  //       })
  //   })
  
  // }

  return (
    <div className={`card ${className}`}>
      <div className='card-header pt-5'>
        <h3 className='card-title d-flex flex-column'>
          <span className='card-label fw-bold text-dark'>{mainLabel}</span>

          <span className='text-muted fw-semibold fs-7'>{sideLabel}</span>
        </h3>
        <div className='card-toolbar'>
          {/* <button
            type='button'
            className='btn btn-sm btn-icon btn-bg-light btn-active-color-primary mb-2'
            data-kt-menu-trigger='click'
            data-kt-menu-placement='bottom-end'
            data-kt-menu-flip='top-end'
            onClick={(e) => { functionDownload() }}
            disabled={isDownloadContinue}
          >
            {!isDownloadContinue && (
              <KTSVG
                path='/media/icons/duotune/arrows/arr044.svg'
                className='svg-icon-3'
              />
            )}pdf
            {isDownloadContinue && (
              <span className='indicator-progress' style={{ display: 'block' }}>
                <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
              </span>
            )}
          </button> */}
          <button
            type='button'
            className='btn btn-sm btn-icon btn-bg-light btn-active-color-primary mb-2'
            data-kt-menu-trigger='click'
            data-kt-menu-placement='bottom-end'
            data-kt-menu-flip='top-end'
            onClick={(e) => { functionDownload() }}
            disabled={isDownloadContinue}
          >
            {!isDownloadContinue && (
              <KTSVG
                path='/media/icons/duotune/arrows/arr044.svg'
                className='svg-icon-3'
              />
            )}
            {isDownloadContinue && (
              <span className='indicator-progress' style={{ display: 'block' }}>
                <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
              </span>
            )}
          </button>
        </div>
      </div>

      {(data![0].firstCount !== -1 && totalDataCount !== 0) &&
        <div className='card-body'>
          {/* begin::Chart */}
          <div ref={chartRef} id='kt_charts_widget_2_chart' style={{ height: height }} />
          {/* end::Chart */}
        </div>
      }
      {(totalDataCount === 0) && (
        <div className='text-center p-11'>
          {warnings.map((warning, key) => (
            <Link key={key} to={warning.url}>
              <div>
                {warning.message}
                &nbsp;<KTSVG path='/media/icons/duotune/arrows/arr095.svg' className='svg-icon-2' />
              </div>
            </Link>
          ))}
          <div>
            <img
              className='mw-100 mh-200px'
              alt='metronic'
              style={{ transform: isWaringImageMirror ? 'scaleX(-1)' : 'scaleX(1)' }}
              src={toAbsoluteUrl('/media/illustrations/sketchy-1/1.png')}
            />
          </div>
        </div>
      )}
      {data![0].firstCount === -1 &&
        <div className='card-header border-0 pt-5'>
          <span className='indicator-progress' style={{ display: 'block' }}>
            {/* Please wait...{' '} */}
            <span className='spinner-border spinner-border-lg align-middle ms-2'></span>
          </span>
          <div className='card-body'>
            {/* begin::Chart */}
            <div style={{ height: height }} />
            {/* end::Chart */}
          </div>
          {/* end::Chart */}
        </div>
      }
    </div>
  )
}

export { ChartsWidget2 }

function getChartOptions(id = 'chartwidget2', height: number, data?: ChartsWidget2Dto[],
  texts = ['Net Profit', 'Revenue'], isHorizontal = false
): ApexOptions {
  const labelColor = getCSSVariableValue('--kt-gray-500')
  const borderColor = getCSSVariableValue('--kt-gray-200')
  let firstArray = []
  let labelArray = []
  let colors = ['#47be7d', '#f1416c', '#e4e6ef']
  if (texts === undefined) {
    texts = ['Net Profit', 'Revenue']
  }
  if (data) {
    colors = []
    for (let i = 0; i < data!.length; i++) {
      let sentimentByMonth = data![i]
      firstArray.push(getHappinessScore(sentimentByMonth.secondCount, sentimentByMonth.thirdCount))
      colors.push(getColorCodeFromDivision(sentimentByMonth.secondCount, sentimentByMonth.thirdCount))
      labelArray.push(sentimentByMonth.label)
    }
  }

  return {
    series: [
      {
        name: texts[0],
        data: firstArray,
      },
    ],
    chart: {
      id: id,
      fontFamily: 'inherit',
      type: 'bar',
      height: height,
      toolbar: {
        show: false,
      },
    },
    plotOptions: {
      bar: {
        horizontal: isHorizontal,
        columnWidth: '50%',
        borderRadius: 5,
        distributed: true,
        dataLabels: {
          position: 'top',
        },
      }
    },
    legend: {
      show: false,
    },
    dataLabels: {
      enabled: true,
      offsetX: -6,
      style: {
        fontSize: '12px',
        colors: ['#fff']
      }
    },
    stroke: {
      show: true,
      width: 2,
      colors: ['transparent'],
    },
    xaxis: {
      categories: labelArray,
      axisBorder: {
        show: false,
      },
      axisTicks: {
        show: false,
      },
      labels: {
        style: {
          colors: labelColor,
          fontSize: '12px',
        },
      },
    },
    yaxis: {
      labels: {
        style: {
          colors: labelColor,
          fontSize: '12px',
        },
      },
    },
    fill: {
      opacity: 1,
    },
    states: {
      normal: {
        filter: {
          type: 'none',
          value: 0,
        },
      },
      hover: {
        filter: {
          type: 'none',
          value: 0,
        },
      },
      active: {
        allowMultipleDataPointsSelection: false,
        filter: {
          type: 'none',
          value: 0,
        },
      },
    },
    tooltip: {
      style: {
        fontSize: '12px',
      },
      y: {
        formatter: function (val) {
          return '' + val + '%'
        },
      },
    },
    colors: colors,
    grid: {
      borderColor: borderColor,
      strokeDashArray: 4,
      yaxis: {
        lines: {
          show: true,
        },
      },
    },
  }
}
